import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { LoginService } from '../services/login.service';
import { UtilitiesService } from '../services/utilities.service';


@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(
    private loginService: LoginService,
    private router: Router,
    private utilityService: UtilitiesService
  ) {}

  async canActivate(): Promise<boolean | UrlTree> {

    const rawUser = await this.utilityService.getObject('usuario');
    const user = JSON.parse(rawUser);

    if (user.id) {
      return true;
    } else {
      return this.router.createUrlTree(['/login']);
    }
  }
}
